var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFirefox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2838 11.666C91.36 15.066 89.9989 22.7197 92.9629 30.4782C95.927 38.2367 100.471 36.5514 103.303 44.4623C107.041 54.9014 105.301 68.9245 105.301 68.9245C105.301 68.9245 109.795 81.9258 112.928 68.116C119.86 42.1758 94.2838 18.0538 94.2838 11.666Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6124 119.359C88.5508 119.359 112.803 95 112.803 64.9683C112.803 34.9367 88.5508 10.5781 58.6417 10.5781C28.7326 10.5781 4.48057 34.9293 4.48057 64.9647C4.42319 95.0293 28.7033 119.359 58.6124 119.359Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2158 98.5048C98.0445 99.3303 96.8158 100.071 95.5389 100.722C97.2304 98.2441 98.7911 95.6796 100.214 93.039C101.369 91.7621 102.428 90.5207 103.29 89.1792C103.71 88.5194 104.182 87.706 104.684 86.7621C107.726 81.2865 111.081 72.4256 111.176 63.3231V62.6329C111.192 60.348 110.958 58.0682 110.479 55.8341C110.503 56.0085 110.525 56.1829 110.547 56.3573C110.52 56.2231 110.497 56.0878 110.469 55.9536C110.514 56.1975 110.55 56.4414 110.591 56.6853C111.212 61.956 110.771 67.0963 108.555 70.8865C108.519 70.9414 108.484 70.9938 108.449 71.0475C109.597 65.2878 109.982 58.9268 108.704 52.5597C108.704 52.5597 108.192 49.4646 104.385 40.067C102.187 34.6585 98.3015 30.2231 94.8625 26.9926C91.8484 23.267 89.1114 20.7731 87.6026 19.1804C84.4505 15.8658 83.1296 13.3792 82.5864 11.7573C82.1164 11.5219 76.0992 5.68289 75.6218 5.46094C72.9959 9.52801 64.7374 22.25 68.6634 34.1378C70.4433 39.5243 74.9467 45.1134 79.6589 48.2524C79.8653 48.489 82.4667 51.3012 83.6985 57.6621C84.9742 64.2292 84.3089 69.3524 81.6793 76.9304C78.592 83.578 70.6899 90.1487 63.2797 90.8207C47.4499 92.2573 41.6536 82.8804 41.6536 82.8804C47.3107 85.1341 53.5648 84.667 57.3675 82.3292C61.2008 79.9597 63.519 78.2036 65.4015 78.8963C67.2546 79.5768 68.7366 77.5731 67.406 75.4999C66.3823 73.925 64.9176 72.6856 63.1941 71.936C61.4706 71.1864 59.5645 70.9597 57.713 71.2841C53.8761 71.9073 50.3602 74.9426 45.3331 72.0024C45.0077 71.8137 44.6927 71.6077 44.3894 71.3853C44.0586 71.167 45.4673 71.717 45.1377 71.4695C44.1611 70.939 42.4276 69.7816 41.9783 69.3695C41.9039 69.3012 42.7377 69.6353 42.6632 69.567C37.962 65.6999 38.5492 63.0877 38.6969 61.4487C38.819 60.1378 39.6735 58.4585 41.1079 57.7768C41.8026 58.156 42.2359 58.4451 42.2359 58.4451C42.2359 58.4451 41.9393 57.8353 41.7794 57.5207C41.8355 57.4963 41.8892 57.5024 41.9454 57.4792C42.5143 57.7536 43.7766 58.467 44.437 58.9024C45.3001 59.5121 45.576 60.0536 45.576 60.0536C45.576 60.0536 45.8031 59.9317 45.6346 59.3987C45.5735 59.1817 45.3111 58.4902 44.4565 57.7926H44.5102C45.0219 58.0826 45.5068 58.4172 45.9593 58.7926C46.2035 57.917 46.6344 57.0024 46.5392 55.367C46.4806 54.217 46.5074 53.9195 46.3048 53.4756C46.1229 53.0938 46.4061 52.9451 46.7223 53.3414C46.6686 53.031 46.578 52.728 46.4525 52.439V52.4097C46.8468 51.039 54.7843 47.4756 55.3642 47.0585C56.3136 46.3886 57.1096 45.5248 57.6996 44.5243C58.1415 43.8219 58.4735 42.8353 58.5541 41.3402C58.598 40.2621 58.0951 39.5439 50.0685 38.7036C47.8711 38.4878 46.5856 36.8987 45.8531 35.4329C45.72 35.117 45.5833 34.8304 45.4466 34.5451C45.3163 34.2109 45.2118 33.8672 45.1341 33.517C46.4464 29.7524 48.6511 26.5658 51.8935 24.1634C52.0705 24.0024 51.1879 24.2048 51.3637 24.0414C51.57 23.8536 52.9153 23.3097 53.1692 23.1878C53.4793 23.0414 51.841 22.3463 50.3944 22.5158C48.9209 22.6817 48.6084 22.8573 47.8222 23.1902C48.1482 22.8658 49.1858 22.4402 48.9429 22.4426C47.3559 22.6865 45.3807 23.6085 43.6935 24.6524C43.6898 24.4704 43.7243 24.2897 43.7949 24.1219C43.0087 24.4548 41.0774 25.8036 40.5146 26.9439C40.539 26.7252 40.55 26.5053 40.5476 26.2853C39.9486 26.7842 39.4084 27.3497 38.9374 27.9707L38.9081 27.9975C34.3473 26.1682 30.3346 26.0463 26.9383 26.8658C26.1949 26.1207 25.8323 26.6658 24.1415 22.9548C24.0268 22.7317 24.2294 23.1756 24.1415 22.9548C23.8632 22.2353 24.3112 23.9146 24.1415 22.9548C21.2996 25.1951 17.5591 27.7341 15.7633 29.5268C15.7413 29.5987 17.8582 28.9292 15.7633 29.5268C15.0309 29.7365 15.0797 30.1707 14.9686 34.1C14.9417 34.3975 14.9686 34.7317 14.9417 35C13.5073 36.8292 12.5307 38.3707 12.1608 39.1719C10.3064 42.3646 8.26285 47.3426 6.28274 55.2146C7.15724 53.0849 8.21046 51.0328 9.43113 49.0804C7.7843 53.2597 6.1924 59.8219 5.875 69.9268C6.27284 67.8413 6.78347 65.779 7.40464 63.7487C7.01521 72.1331 8.46213 80.5014 11.6444 88.2695C12.7834 91.0524 14.6671 95.2768 17.8704 99.9036C27.9504 110.5 42.1615 117.085 57.8973 117.085C74.3266 117.085 89.0797 109.906 99.2158 98.5048Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0599 106.197C106.943 103.897 115.748 83.4282 104.441 83.0258C94.232 82.6953 77.6477 107.282 87.0599 106.197Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.873 78.8436C119.552 70.8912 115.98 53.7119 115.98 53.7119C115.98 53.7119 110.7 59.8387 107.115 69.6046C103.577 79.2802 97.649 83.6473 105.873 78.8436Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4451 116.361C81.5173 122.44 97.9124 107.432 87.8056 102.419C78.6241 97.9 53.393 113.487 62.4451 116.361Z",
    fill: "url(#paint5_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.294 86.138C107.758 85.4843 108.385 83.3904 108.94 82.4538C112.307 77.0246 112.331 72.6977 112.331 72.5953C114.365 62.4465 114.181 58.3026 112.929 50.6441C111.922 44.4734 107.519 35.6331 103.704 31.3758C99.7729 26.9856 102.543 28.4185 98.7364 25.2148C95.4 21.5209 92.1662 17.8624 90.4046 16.3904C77.6743 5.75508 77.9612 3.49776 78.2066 3.1124C78.1651 3.15752 78.104 3.22459 78.0271 3.3124C77.8757 2.7124 77.7695 2.20752 77.7695 2.20752C77.7695 2.20752 70.8111 9.15874 69.3462 20.7441C68.3903 28.3051 71.2237 36.1929 75.328 41.2319C77.4652 43.8434 79.8802 46.2151 82.5306 48.3051C85.6314 52.7538 87.338 58.2429 87.338 64.1477C87.338 78.9331 75.3329 90.9197 60.5236 90.9197C58.5054 90.921 56.4935 90.6952 54.5259 90.2465C47.5381 88.9148 43.5022 85.3929 41.4904 83.0014C40.3368 81.6319 39.8472 80.6331 39.8472 80.6331C46.1074 82.8734 53.0317 82.4051 57.2397 80.0819C61.4819 77.7331 64.048 75.9904 66.1318 76.677C68.1852 77.3612 69.8198 75.3758 68.3537 73.3185C66.9168 71.2636 63.1776 68.3185 57.6254 69.1368C53.3784 69.7551 49.4877 72.766 43.9234 69.849C43.5654 69.6635 43.217 69.46 42.8796 69.2392C42.5134 69.0234 44.0723 69.5673 43.7086 69.3221C42.6257 68.7953 40.7091 67.6478 40.2122 67.2404C40.1292 67.1721 41.0521 67.5038 40.9691 67.4356C35.7662 63.6002 36.4156 61.0099 36.5743 59.3868C36.7049 58.0868 37.6498 56.4209 39.2429 55.7453C40.012 56.1209 40.4918 56.4075 40.4918 56.4075C40.4918 56.4075 40.1634 55.8075 39.9864 55.4917C40.0487 55.4685 40.1085 55.4734 40.1695 55.4502C40.7994 55.7221 42.1936 56.4258 42.9273 56.8612C43.8831 57.4648 44.1871 58.0026 44.1871 58.0026C44.1871 58.0026 44.4386 57.8807 44.253 57.3526C44.1847 57.1368 43.8953 56.4514 42.9492 55.7587H43.0078C43.5693 56.0451 44.1055 56.3784 44.6107 56.7551C44.8781 55.8868 45.3578 54.9795 45.2516 53.3575C45.1869 52.2173 45.2174 51.9209 44.9928 51.4807C44.7914 51.1026 45.1051 50.9551 45.4543 51.3478C45.3944 51.0377 45.2943 50.7368 45.1564 50.4526V50.4234C45.5922 49.0648 54.3769 45.5307 55.0166 45.1173C56.047 44.4713 56.928 43.6137 57.601 42.6014C58.0893 41.9039 58.4556 40.927 58.5471 39.4441C58.5777 38.7758 58.3713 38.2465 56.0445 37.7368C54.648 37.4331 52.4872 37.138 49.1557 36.8258C46.7263 36.6112 45.3004 35.0356 44.4911 33.5819C44.3434 33.2685 44.192 32.9843 44.0418 32.7014C43.8987 32.3717 43.7832 32.0307 43.6963 31.6819C45.1502 27.8803 47.7682 24.6342 51.1773 22.4063C51.3726 22.2465 50.396 22.4465 50.5913 22.2843C50.8196 22.099 52.3077 21.5612 52.5897 21.4404C52.9328 21.2953 51.1248 20.6063 49.5182 20.7734C47.8873 20.938 47.5418 21.1124 46.6714 21.4429C47.0376 21.1209 48.1815 20.699 47.9117 20.7014C46.1538 20.9453 43.9686 21.8575 42.1008 22.8965C42.0974 22.7151 42.1359 22.5352 42.2131 22.3709C41.3427 22.7014 39.2051 24.038 38.5837 25.1758C38.6102 24.9594 38.622 24.7414 38.6191 24.5234C37.9637 25.0112 37.3658 25.5717 36.8368 26.1941L36.8038 26.2209C31.7632 24.4026 27.3208 24.2807 23.5669 25.1002C22.7441 24.3612 21.422 23.2429 19.5518 19.5636C19.4297 19.3417 19.3564 20.0209 19.2588 19.8075C18.5263 18.1234 18.0929 15.3636 18.1601 13.4661C18.1601 13.4661 16.6561 14.1502 15.4121 17.01C15.1814 17.5234 15.0324 17.8075 14.8847 18.0917C14.8163 18.1746 15.0398 17.1526 15.0068 17.2087C14.7907 17.5746 14.2304 18.0856 13.985 18.7478C13.8165 19.2356 13.5797 19.5124 13.4283 20.1246L13.3929 20.1807C13.3807 20.0002 13.4381 19.4392 13.3929 19.5539C12.8092 20.7279 12.3067 21.9405 11.8889 23.1831C11.2187 25.3782 10.4386 28.3795 10.3153 32.277C10.286 32.5721 10.3153 32.9039 10.2848 33.1697C8.6978 34.9782 7.61619 36.5099 7.20845 37.3051C5.15632 40.4758 2.89543 45.4075 0.702909 53.2148C1.67814 51.0817 2.84424 49.0409 4.18702 47.1173C2.36439 51.2624 0.602805 57.7709 0.25 67.7929C0.691859 65.7188 1.25727 63.6728 1.94322 61.666C1.62826 68.349 2.40834 76.6343 6.63712 85.988C9.14827 91.4758 14.9287 102.647 29.0531 111.354C29.0531 111.354 33.8581 114.927 42.1154 117.605C42.7258 117.826 43.3435 118.044 43.9747 118.255C43.7769 118.174 43.5853 118.092 43.3997 118.011C48.8976 119.657 54.6059 120.496 60.3453 120.5C81.731 120.518 88.0387 111.939 88.0387 111.939L87.9765 111.986C88.2784 111.702 88.569 111.407 88.8481 111.1C85.4739 114.281 77.7695 114.495 74.8946 114.271C79.8046 112.831 83.036 111.611 89.3206 109.207C90.053 108.934 90.805 108.624 91.5766 108.276L91.8207 108.161C91.9733 108.09 92.1247 108.023 92.2785 107.949C95.3407 106.507 98.22 104.706 100.856 102.583C107.167 97.5465 108.547 92.6368 109.258 89.4002C109.158 89.7099 108.847 90.4331 108.627 90.9026C107.002 94.3758 103.397 96.5124 99.4823 98.3416C101.345 95.8997 103.072 93.3577 104.656 90.727C105.941 89.4502 106.336 87.4697 107.294 86.138Z",
    fill: "url(#paint6_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6132 98.1829C102.187 95.3488 104.496 92.1073 106.248 88.4268C110.753 78.9658 117.724 63.2341 112.23 46.8036C107.896 33.8195 101.942 26.7195 94.3871 19.7829C82.1121 8.51951 78.6842 3.49024 78.6842 0.5C78.6842 0.5 64.5121 16.2817 70.6588 32.7415C76.8054 49.2012 89.3929 48.5951 97.721 65.7744C107.52 85.9866 89.7921 108.044 75.1366 114.218C76.0339 114.019 107.731 106.855 109.393 88.7451C109.35 89.078 108.636 94.0866 99.6132 98.1829Z",
    fill: "url(#paint7_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5523 39.4475C58.5999 38.378 58.0444 37.6597 49.1913 36.8305C45.5485 36.4939 44.1544 33.1317 43.7283 31.7158C42.4331 35.0768 41.8972 38.6048 42.1853 42.8719C42.3818 45.667 44.2606 48.667 45.1603 50.4329C45.1603 50.4329 45.3605 50.1731 45.4521 50.078C47.1441 48.3183 54.2344 45.6365 54.8997 45.2561C55.6346 44.7878 58.429 42.7487 58.5523 39.4475Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5756 19.5819C19.4536 19.36 19.3803 20.0393 19.2826 19.8258C18.5502 18.1417 18.1131 15.4112 18.2181 13.4844C18.2181 13.4844 16.7141 14.1685 15.4701 17.0283C15.2394 17.5417 15.0905 17.8258 14.9428 18.1088C14.8744 18.1917 15.0978 17.1697 15.0648 17.2258C14.8488 17.5917 14.2884 18.1027 14.0455 18.7356C13.8441 19.2527 13.6365 19.5307 13.4827 20.171C13.4351 20.3453 13.5303 19.4002 13.4827 19.5149C10.5919 25.0953 10.0389 33.549 10.3441 33.1831C16.5066 26.6149 23.5664 25.0563 23.5664 25.0563C22.8156 24.5039 21.1822 22.9063 19.5744 19.5819H19.5756Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9585 88.3171C34.4472 84.6866 24.7688 79.5671 25.1351 67.9342C25.6332 52.6159 39.4377 55.644 39.4377 55.644C38.9165 55.7659 37.5236 56.761 37.0304 57.8171C36.5091 59.1379 35.5569 62.1196 38.4404 65.244C42.9682 70.1452 29.138 76.8732 50.4846 89.5818C51.0229 89.8744 45.4794 89.4074 42.9597 88.3183L42.9585 88.3171Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9321 80.6827C45.9676 82.7815 52.9944 82.4132 57.2086 80.09C60.0274 78.5229 63.6421 76.0132 65.8663 76.6327C63.94 75.8717 62.4811 75.5168 60.7269 75.4303C60.4278 75.4303 60.0701 75.4303 59.7502 75.3912C59.1074 75.389 58.465 75.424 57.8263 75.4961C56.7398 75.5961 55.5349 76.2803 54.4398 76.1705C54.3812 76.1705 55.5019 75.7107 55.4165 75.7303C54.8366 75.8522 54.2055 75.8778 53.5401 75.9595C53.1165 76.0071 52.7527 76.0595 52.3328 76.0815C39.7587 77.1461 29.138 69.2754 29.138 69.2754C28.2334 72.3242 33.1873 78.3364 39.9443 80.6864L39.9321 80.6827Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5889 98.262C112.305 85.7901 118.738 70.6303 116.018 53.6279C116.018 53.6279 117.105 62.3474 112.985 71.2657C114.963 62.5596 115.194 51.7401 109.933 40.534C102.917 25.5779 91.3743 17.7084 86.9672 14.4255C80.2908 9.45106 77.5245 4.38643 77.472 3.34131C75.4773 7.42423 69.443 21.4145 76.8238 33.4632C83.7383 44.751 94.6301 48.0974 102.256 58.4632C116.305 77.5327 99.5889 98.262 99.5889 98.262Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7656 65.8108C93.322 56.64 87.7784 52.6401 82.5291 48.3047C83.1395 49.1583 83.2896 49.4596 83.6278 50.012C88.246 54.9291 95.0555 66.9218 90.1113 81.9766C80.8053 110.314 43.5862 96.9705 39.6797 93.2217C41.2582 109.623 68.7342 117.471 86.6309 106.841C96.8122 97.2071 105.049 80.84 97.7656 65.8108Z",
    fill: "url(#paint13_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.665 37.6038) rotate(2.25816) scale(41.8648 61.6442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E0255A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CC2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.5871 19.2037) scale(118.808 118.684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#007AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#005FE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2639AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#401E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4A1475"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 66.2511,
    y1: 89.4268,
    x2: 42.9249,
    y2: 13.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000F43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#001962",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.041 80.2325) rotate(5.61179) scale(39.9407 39.9001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.193 41.8043) rotate(5.61179) scale(66.697 66.6292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFAF0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF4E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF2C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FF0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.53 104.194) rotate(5.61178) scale(61.2018 61.1394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#620700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.559 48.5539) scale(95.487 95.3878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E91C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CF0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B5007F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0853 4.31585) scale(108.826 108.713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FF6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF4A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 18.39,
    y1: 45.0492,
    x2: 65.2618,
    y2: 37.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF2C2C",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF7A1A",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFB20D",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFD605",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 17.9525,
    y1: 32.7709,
    x2: 13.074,
    y2: 15.2184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 26.9612,
    y1: 57.4071,
    x2: 37.0164,
    y2: 71.4684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF272D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 46.5699,
    y1: 81.8708,
    x2: 47.4894,
    y2: 72.8432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C42482",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C42482",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C42482",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C42482",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C42482",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C42482",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C42482",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 76.001,
    y1: 4.90472,
    x2: 113.251,
    y2: 88.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFEE4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFD834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFC41E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFAB02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 83.369,
    y1: 52.8425,
    x2: 65.7268,
    y2: 100.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF8E00",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF8E00",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF8E00",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FF8E00",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF8E00",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF8E00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF8E00",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF8E00",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF8E00",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF8E00",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFirefox);
export default __webpack_public_path__ + "static/media/logo-firefox.c12ecb5eba115d52b78ac5b24c9924f5.svg";
export { ForwardRef as ReactComponent };